// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.callout {
  width: 300px;
  position: absolute;
  z-index: 999;
  right: 0;
  bottom: 100%;
  display: none;
  text-align: left;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
.callout.callout-open {
  display: block;
}
.callout .btn-delete {
  background: #dc3545;
  color: #fff;
  border: 0;
  padding: 6px 10px 1px;
}
.callout .btn-add {
  color: #fff;
  border: 0;
  padding: 6px 10px 1px;
}
.callout .checkbox {
  font-size: 12px;
}
.callout .checkbox input + span {
  margin-right: 5px;
  display: inline;
}

.callout-header {
  position: relative;
}

.callout-header {
  padding: 10px 15px;
}

.callout-body .callout-body-inner {
  padding: 10px 0;
}

.callout-body {
  min-height: 250px;
}
.callout-body .items {
  list-style: none;
  margin: 0;
  padding: 0;
}
.callout-body .callout-list-form,
.callout-body .callout-list-item {
  padding: 6px 15px;
}

.callout-filter {
  padding: 6px;
  border-bottom: 1px solid transparent;
}

.callout-filter-table {
  width: 100%;
}

.callout-actions {
  float: right;
  -webkit-user-select: none;
          user-select: none;
}
.callout-actions span {
  line-height: inherit;
  display: inline-block;
}
.callout-actions .action {
  cursor: pointer;
}
.callout-actions .material-icons {
  font-size: 16px;
  line-height: 1;
  padding-left: 2px;
  padding-right: 2px;
}
.callout-actions {
  /* span {
  	color: #666;
  	//&:hover {
  	//	color: \$themeColor;
  	//}
  } */
}

/* .callout-header-actions {
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	padding: 6px 5px 5px 15px;
	> span {
		display: inline-block;
		vertical-align: top;
	}
} */
.callout-close {
  background: none;
  color: #fff;
  border: 0;
  padding: 1px 0 0;
  line-height: 1;
  float: right;
  cursor: pointer;
  outline: 0;
  width: 30px;
  margin-right: -10px;
}
.callout-close i {
  line-height: inherit;
}
.callout-close:hover {
  color: #dc3545;
}

.colorPicker-trigger {
  cursor: pointer;
}

.callout-edit-view {
  background: #f3f3f3;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px 15px;
}
.callout-edit-view input {
  border-radius: 0;
}
.callout-edit-view select,
.callout-edit-view textarea {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 0;
}

.callout-body-scroll {
  min-height: inherit;
  height: 250px;
  max-height: 300px;
}

.callout-body-scroll-edit-mode {
  max-height: 484px;
}

.page-title-notification,
.page-title,
.page-title-2,
.with-border {
  position: relative;
  padding-left: 15px;
  min-width: calc(25% - 12px);
  text-align: left;
}
.page-title-notification:before,
.page-title:before,
.page-title-2:before,
.with-border:before {
  content: "";
  display: block;
  height: 100%;
  width: 5px;
  position: absolute;
  left: 0;
  top: 0;
}

@media (max-height: 600px) {
  .callout-body-scroll {
    max-height: 200px;
  }
  .callout {
    width: 300px;
  }
}
@media (max-width: 767px) {
  .callout {
    right: 0;
  }
}
@media (max-width: 479px) {
  .callout {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Features/Callout/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yHAAA;EACA,gBAAA;AADD;AAGC;EACC,cAAA;AADF;AAIC;EACC,mBCoCS;EDnCT,WAAA;EACA,SAAA;EACA,qBAAA;AAFF;AAKC;EACC,WAAA;EACA,SAAA;EACA,qBAAA;AAHF;AAMC;EACC,eCiDa;ADrDf;AAME;EACC,iBAAA;EACA,eAAA;AAJH;;AAUA;EACC,kBAAA;AAPD;;AAUA;EACC,kBAAA;AAPD;;AAUA;EACC,eAAA;AAPD;;AAUA;EACC,iBAAA;AAPD;AASC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AAPF;AAUC;;EAEC,iBAAA;AARF;;AAYA;EACC,YAAA;EACA,oCAAA;AATD;;AAYA;EACC,WAAA;AATD;;AAYA;EACC,YAAA;EACA,yBAAA;UAAA,iBAAA;AATD;AAWC;EACC,oBAAA;EACA,qBAAA;AATF;AAYC;EACC,eAAA;AAVF;AAaC;EACC,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAXF;AANA;EAwBC;;;;;KAAA;AAVD;;AAmBA;;;;;;;;;;GAAA;AAWA;EACC,gBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,oBAAA;AAhBF;AAmBC;EACC,cCpFS;ADmEX;;AAqBA;EACC,eAAA;AAlBD;;AAqBA;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAlBD;AAoBC;EACC,gBAAA;AAlBF;AAqBC;;EAEC,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAnBF;;AAuBA;EACC,mBAAA;EACA,aAAA;EACA,iBAAA;AApBD;;AAuBA;EACC,iBAAA;AApBD;;AAwBA;;;;EAIC,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AArBD;AAuBC;;;;EACC,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AAlBF;;AAyBA;EACC;IACC,iBAAA;EAtBA;EAyBD;IACC,YAAA;EAvBA;AACF;AA0BA;EACC;IACC,QAAA;EAxBA;AACF;AA2BA;EACC;IACC,WAAA;IACA,eAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;EAzBA;AACF","sourcesContent":["@import './../../../assets/variables';\n\n.callout {\n\twidth: 300px;\n\tposition: absolute;\n\tz-index: 999;\n\tright: 0;\n\tbottom: 100%;\n\tdisplay: none;\n\ttext-align: left;\n\tbox-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n\toverflow: hidden;\n\n\t&.callout-open {\n\t\tdisplay: block;\n\t}\n\n\t.btn-delete {\n\t\tbackground: $danger;\n\t\tcolor: #fff;\n\t\tborder: 0;\n\t\tpadding: 6px 10px 1px;\n\t}\n\n\t.btn-add {\n\t\tcolor: #fff;\n\t\tborder: 0;\n\t\tpadding: 6px 10px 1px;\n\t}\n\n\t.checkbox {\n\t\tfont-size: $baseFontSize;\n\n\t\tinput+span {\n\t\t\tmargin-right: 5px;\n\t\t\tdisplay: inline;\n\t\t}\n\n\t}\n}\n\n.callout-header {\n\tposition: relative;\n}\n\n.callout-header {\n\tpadding: 10px 15px;\n}\n\n.callout-body .callout-body-inner {\n\tpadding: 10px 0;\n}\n\n.callout-body {\n\tmin-height: 250px;\n\n\t.items {\n\t\tlist-style: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n\n\t.callout-list-form,\n\t.callout-list-item {\n\t\tpadding: 6px 15px;\n\t}\n}\n\n.callout-filter {\n\tpadding: 6px;\n\tborder-bottom: 1px solid $borderColor;\n}\n\n.callout-filter-table {\n\twidth: 100%;\n}\n\n.callout-actions {\n\tfloat: right;\n\tuser-select: none;\n\n\tspan {\n\t\tline-height: inherit;\n\t\tdisplay: inline-block;\n\t}\n\n\t.action {\n\t\tcursor: pointer;\n\t}\n\n\t.material-icons {\n\t\tfont-size: 16px;\n\t\tline-height: 1;\n\t\tpadding-left: 2px;\n\t\tpadding-right: 2px;\n\n\t\t.fms-sidebar & {\n\t\t\t//line-height: 35px;\n\t\t}\n\t}\n\n\t/* span {\n\t\tcolor: #666;\n\t\t//&:hover {\n\t\t//\tcolor: $themeColor;\n\t\t//}\n\t} */\n\n}\n\n/* .callout-header-actions {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tpadding: 6px 5px 5px 15px;\n\t> span {\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t}\n} */\n.callout-close {\n\tbackground: none;\n\tcolor: #fff;\n\tborder: 0;\n\tpadding: 1px 0 0;\n\tline-height: 1;\n\tfloat: right;\n\tcursor: pointer;\n\toutline: 0;\n\twidth: 30px;\n\tmargin-right: -10px;\n\n\ti {\n\t\tline-height: inherit;\n\t}\n\n\t&:hover {\n\t\tcolor: $danger\n\t}\n}\n\n.colorPicker-trigger {\n\tcursor: pointer\n}\n\n.callout-edit-view {\n\tbackground: #f3f3f3;\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\tpadding: 10px 15px;\n\n\tinput {\n\t\tborder-radius: 0;\n\t}\n\n\tselect,\n\ttextarea {\n\t\twidth: 100%;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 5px;\n\t\tborder-radius: 0;\n\t}\n}\n\n.callout-body-scroll {\n\tmin-height: inherit;\n\theight: 250px;\n\tmax-height: 300px;\n}\n\n.callout-body-scroll-edit-mode {\n\tmax-height: 484px;\n}\n\n\n.page-title-notification,\n.page-title,\n.page-title-2,\n.with-border {\n\tposition: relative;\n\tpadding-left: 15px;\n\tmin-width: calc(25% - 12px);\n\ttext-align: left;\n\n\t&:before {\n\t\tcontent: \"\";\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\twidth: 5px;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n}\n\n\n// responsive \n\n@media (max-height: 600px) {\n\t.callout-body-scroll {\n\t\tmax-height: 200px;\n\t}\n\n\t.callout {\n\t\twidth: 300px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.callout {\n\t\tright: 0;\n\t}\n}\n\n@media (max-width: 479px) {\n\t.callout {\n\t\twidth: 100%;\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tz-index: 9;\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
